import { Dialog } from "@headlessui/react";

interface ParseFailedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onTryAgain: () => void;
  title?: string;
  message?: string;
  hideTryAgain?: boolean;
}

const ParseFailedModal = ({
  isOpen,
  onClose,
  onTryAgain,
  title = "Unable to Parse image",
  message = "We were not able to parse the image. Press “Take again” to take another picture or “Cancel” to enter the number manually",
  hideTryAgain = false,
}: ParseFailedModalProps) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-135 rounded-2xl bg-white md:px-8 px-4 md:py-9 py-8 shadow-xl text-center">
          <Dialog.Title className="md:text-3xl text-xl font-semibold text-gray-900">
            {title}
          </Dialog.Title>

          <p className="md:text-xl text-sm font-normal text-[#848484] mt-4">
            {message}
          </p>

          <div className="mt-6 flex justify-center md:gap-3 gap-2">
            <button
              onClick={onClose}
              className="px-7 py-2 md:text-lg text-base w-full font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 cursor-pointer"
            >
              {hideTryAgain ? "Close" : "Cancel"}
            </button>
            {!hideTryAgain && (
              <button
                onClick={onTryAgain}
                className="px-7 py-2 md:text-lg text-base w-full font-medium text-white bg-[#0960FB] rounded-lg hover:bg-blue-700 cursor-pointer"
              >
                Take Again
              </button>
            )}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ParseFailedModal;
